import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Faq from "./FAQ";
import styles from "./FAQBlock.module.scss";

interface FaqData {
  question: string;
  answer: string;
  description?: string;
}

interface FaqBlockProps {
  faqData: FaqData[];
  title?: string;
  subtitle?: string;
  showNumbers?: boolean;
  showAllButton?: boolean;
  variant?: "default" | "mini" | "job";
}

const FaqBlock: React.FC<FaqBlockProps> = ({
  faqData,
  title,
  subtitle,
  showNumbers = false,
  showAllButton = false,
  variant = "default",
}) => {
  const { t } = useTranslation("common");
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getTitle = () => {
    if (title) return title;
    if (variant === "mini") return t("faq.frequentQuestions");
    if (variant === "job") return t("faq.openPositions");
    return t("faq.title");
  };

  return (
    <div className={`container ${variant === "default" ? "" : "section"}`}>
      <div
        className={`sectionContainer sectionContainerWhite bigSection ${
          variant === "default" ? "top12" : ""
        }`}
      >
        <div
          className={`sectionTitle sideP64 ${
            showAllButton ? "sectionTitleButton" : ""
          }`}
        >
          {variant === "job" ? (
            <div className={styles.faqMiniTitle}>
              <h2>{getTitle()}</h2>
              {subtitle && <p className="pageSubitle">{subtitle}</p>}
            </div>
          ) : (
            <>
              <h2
                className={variant === "default" ? `w64 ${styles.title}` : ""}
              >
                {getTitle()}
              </h2>
              {showAllButton && (
                <Link to="/faq" className={styles.buttonLink}>
                  {" "}
                  {/* ← ВЖЕ ВИПРАВЛЕНО */}
                  <button className="commonButton buttonMd buttonWhiteBg">
                    {t("faq.allQuestionsButton")}
                  </button>
                </Link>
              )}
            </>
          )}
        </div>
        <div
          className={`sideP64 ${
            variant === "default" ? styles.faqSectionBlock : "top30"
          }`}
        >
          {faqData.map((faq, index) => (
            <Faq
              key={index}
              question={faq.question}
              answer={faq.answer}
              number={showNumbers ? index + 1 : undefined}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
              description={faq.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqBlock;
